import AndroidRoundedIcon from '@mui/icons-material/AndroidRounded';
import PhoneIphoneRoundedIcon from '@mui/icons-material/PhoneIphoneRounded';
import SmartphoneRoundedIcon from '@mui/icons-material/SmartphoneRounded';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { MOBILE_NAMESPACE } from '@/i18n';
import '@/Pages/Mobile/MobilePage.sass';

const IOS_STEP_COUNT = 3;
const ANDROID_STEP_COUNT = 3;

function InstructionPlatform({
  icon,
  label,
  stepKeys,
}: {
  icon: JSX.Element;
  label: string;
  stepKeys: string[];
}): JSX.Element {
  const { t } = useTranslation(MOBILE_NAMESPACE);

  return (
    <Box
      className="mobile-validation-instructions__platform"
      data-testid={`mobile-validation-instructions-${label.toLowerCase()}`}
    >
      <Box className="mobile-validation-instructions__platform-header">
        <Box
          className="mobile-validation-instructions__platform-icon"
          aria-hidden
        >
          {icon}
        </Box>
        <Typography
          component="h3"
          className="mobile-validation-instructions__platform-label"
        >
          {label}
        </Typography>
      </Box>

      <Box
        component="ol"
        className="mobile-validation-instructions__steps"
      >
        {stepKeys.map((stepKey, index) => (
          <Typography
            key={stepKey}
            component="li"
            className="mobile-validation-instructions__step"
            data-testid={`mobile-validation-instructions-${label.toLowerCase()}-step-${index}`}
          >
            {t(stepKey)}
          </Typography>
        ))}
      </Box>
    </Box>
  );
}

export function ScanInstructions(): JSX.Element {
  const { t } = useTranslation(MOBILE_NAMESPACE);

  const iosStepKeys = Array.from({ length: IOS_STEP_COUNT }, (_, index) =>
    `instructions.ios.${index}`,
  );
  const androidStepKeys = Array.from(
    { length: ANDROID_STEP_COUNT },
    (_, index) => `instructions.android.${index}`,
  );

  return (
    <Box
      component="section"
      className="mobile-validation-instructions"
      data-testid="mobile-validation-instructions"
      aria-labelledby="mobile-instructions-title"
    >
      <Box className="mobile-validation-instructions__title-row">
        <SmartphoneRoundedIcon
          className="mobile-validation-instructions__phone-icon"
          aria-hidden
        />
        <Typography
          id="mobile-instructions-title"
          component="h2"
          className="mobile-validation-instructions__title"
        >
          {t('instructions.title')}
        </Typography>
      </Box>

      <InstructionPlatform
        icon={<PhoneIphoneRoundedIcon fontSize="inherit" />}
        label={t('instructions.iosLabel')}
        stepKeys={iosStepKeys}
      />
      <InstructionPlatform
        icon={<AndroidRoundedIcon fontSize="inherit" />}
        label={t('instructions.androidLabel')}
        stepKeys={androidStepKeys}
      />
    </Box>
  );
}
